const Upwards = () => "\u2191";

export default Upwards;
